import { useMediaQuery } from 'react-responsive';

interface Breakpoints {
  isBreakpointXS: boolean;
  isBreakpointS: boolean;
  isBreakpointM: boolean;
  isBreakpointML: boolean;
  isBreakpointL: boolean;
  isBreakpointXL: boolean;
  isBreakpointXXL: boolean;
}

export const BREAKPOINT_XS = 0;
export const BREAKPOINT_S = 512;
export const BREAKPOINT_M = 768;
export const BREAKPOINT_ML = 991;
export const BREAKPOINT_L = 1024;
export const BREAKPOINT_XL = 1280;
export const BREAKPOINT_XXL = 1440;

export const useBreakpoints = (): Breakpoints => ({
  isBreakpointXS: useMediaQuery({ minWidth: BREAKPOINT_XS }),
  isBreakpointS: useMediaQuery({ minWidth: BREAKPOINT_S }),
  isBreakpointM: useMediaQuery({ minWidth: BREAKPOINT_M }),
  isBreakpointML: useMediaQuery({ minWidth: BREAKPOINT_ML }),
  isBreakpointL: useMediaQuery({ minWidth: BREAKPOINT_L }),
  isBreakpointXL: useMediaQuery({ minWidth: BREAKPOINT_XL }),
  isBreakpointXXL: useMediaQuery({ minWidth: BREAKPOINT_XXL }),
});
